import React from 'react';
import { Box, Tabs, Tab, Grid, CircularProgress, Typography } from '@mui/material';
import type { PisoResponse, MesaResponse } from '../types/pos.types';
import { TableCard } from './TableCard';

interface FloorPlanProps {
  pisos: PisoResponse[];
  pisoActivo: number;
  onPisoChange: (idPiso: number) => void;
  onMesaClick: (mesa: MesaResponse) => void;
  loading: boolean;
}

export const FloorPlan: React.FC<FloorPlanProps> = ({
  pisos,
  pisoActivo,
  onPisoChange,
  onMesaClick,
  loading,
}) => {
  const mesasDelPiso = pisos.find((p) => p.idPiso === pisoActivo)?.mesas ?? [];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Tabs
        value={pisoActivo}
        onChange={(_e, val) => onPisoChange(val)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {pisos.map((piso) => (
          <Tab
            key={piso.idPiso}
            value={piso.idPiso}
            label={`${piso.nombre} (${piso.mesas.length})`}
          />
        ))}
      </Tabs>

      <Box sx={{ flexGrow: 1, overflow: 'auto', p: 1 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : mesasDelPiso.length > 0 ? (
          <Grid container spacing={1}>
            {mesasDelPiso.map((mesa) => (
              <Grid key={mesa.idMesa} size={{ xs: 6, sm: 4, md: 3, lg: 2 }}>
                <TableCard mesa={mesa} onClick={onMesaClick} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="text.secondary">
              {pisos.length === 0 ? 'No hay pisos configurados' : 'No hay mesas en este piso'}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FloorPlan;
